var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isStandardColor)?_c('el-tag',{attrs:{"type":_vm.elementUiType,"size":_vm.size}},[_vm._t("default")],2):_c('span',{class:['custom-color-tag', _vm.sizeClass],style:(_vm.tagStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }